import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "game-board" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"color-legend mt-4\"><div class=\"legend-item flex items-center mb-2\"><div class=\"legend-color bg-red-500 w-4 h-4 mr-2\"></div><span>Lettre correcte et bien placée</span></div><div class=\"legend-item flex items-center mb-2\"><div class=\"legend-color bg-yellow-500 w-4 h-4 mr-2\"></div><span>Lettre correcte mais mal placée</span></div><div class=\"legend-item flex items-center\"><div class=\"legend-color bg-gray-400 w-4 h-4 mr-2\"></div><span>Lettre absente du mot mystère</span></div></div>", 1)


import LetterTile from './LetterTile.vue';
import { Attempt } from '../types/game.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'GameBoard',
  props: {
    attempts: {},
    gameOver: { type: Boolean },
    correctWord: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attempts, (attempt) => {
      return (_openBlock(), _createElementBlock("div", {
        key: attempt.id,
        class: "flex justify-center mb-2"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attempt.letters, (letter, index) => {
          return (_openBlock(), _createBlock(LetterTile, {
            key: index,
            letter: letter.value,
            status: letter.status
          }, null, 8, ["letter", "status"]))
        }), 128))
      ]))
    }), 128)),
    _hoisted_2
  ]))
}
}

})